
















import Vue from 'vue';
import Component from 'vue-class-component';
import type { SubBrand, Theme } from '../../store/modules/themes';
import { Modules } from '../../store/store';
import { namespace } from 'vuex-class';
import SubHeadline from '../sub-headline/sub-headline.vue';
import VueI18n from 'vue-i18n';

const themeModule = namespace(Modules.themes);

@Component({
  name: 'eqweb-faq',
  components: { SubHeadline },
})
export default class Faq extends Vue {
  @themeModule.Getter('propsTheme')
  private readonly theme!: Theme;

  @themeModule.Getter('subBrand')
  private readonly subBrand!: SubBrand;

  private showAllLink(): VueI18n.TranslateResult | string {
    return this.$t('FAQ.SHOW_ALL.LINK') ? this.$t('FAQ.SHOW_ALL.LINK') : '';
  }
}
